import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { QuestionCircleOutlined, RetweetOutlined } from '@ant-design/icons';
import { Tooltip, Popover, message } from 'antd';
import EditableTable from '@/components/EditableTable';
import { getSelectedDesignIDs } from '@/services/helper/dataProcess';
import {
  updateInterfaces,
  editComponentType,
  saveRepeater,
  saveChip,
  saveRLC,
  saveCompPackageModel,
  updateCompComponents,
  saveSplitComponents,
  saveMergeComponents,
  updateProbePins,
  updateAssignStatus,
  updateGetCompPrefixStatus,
  updateDiodeModel
} from '../../store/sierra/action';
import { getLibraryRepeaterFile, getIbisModelList, getSpiceModelList, getFolderFileDetail,/*  getSpiceParseModels, getTouchstoneParsePorts, */ getTouchstoneParse, getPkgSpiceModelList, getIbisPackageList } from '@/services/Sierra/library';
import {
  PackageModelInfo,
  PackageModelFileInfo,
  getIBISPackageText,
  getSpicePackageText,
  getProbePinsText,
  getRepeaterText,
  getModelFileText,
  getComponentsByPCB,
  getCompTypeDisplay
} from '@/services/Sierra'
import { selectChange, selectLayer, changeDisplaySelected } from '../../../LayoutExplorer/store/Sierra/actionCreators';
import { SortFn } from '@/services/helper/sort';
import { getLibraryFileContent } from '@/services/Sierra/library';
import { autoSelectTouchstonePorts } from '@/services/helper/touchstoneHelper';
import PinNodeConnect from '@/components/pinNodeConnect';
import TableTag from '@/components/TableTag';
import { isMac } from '@/services/api/userAgent';
import {
  ICTypes,
  RLCTypes,
  ChipTypes,
  probePinsPointTypes
} from '../../constants';
import {
  CAP,
  IND,
  RES,
  IC,
  COMP_REPEATER,
  CONNECTOR,
  TEST_POINT,
  UNUSED,
  IGNORE,
  JUMPER,
  CHIP,
  TEST_POINT_DISPLAY,
  IC_MASTER
} from '@/constants/componentType';
import PackageModel from '@/components/PackageModel';
import ICModelPanel from '@/components/ICModelPanel';
import { SIERRA } from '@/constants/pageType';
import ProbePinsPanel from '@/components/ProbePinsPanel';
import { getSplitPartName } from '@/services/helper/setDefaultName';
import { parseSpiceModelSelector } from '../../../../services/LibraryHelper/SpiceModelHelper';
import RLCCompModel from '@/components/RLCCompModel';
import { RLCModelInfo, getRLCValue, PassiveModel, getModelValue, getModelTypeName, formatRLCValue } from '../../../../services/RLCModel';
import canvas from '@/services/LayoutCanvas';
import componentSetting from '../../../../services/helper/componentsHelper/compSettingHelper';
import { autoAssignRepeaterPorts } from '../../../../services/Sierra/library';
import auroraDBJson from '../../../../services/Designs/auroraDbData';
import compTableHelper from '../../../../services/Sierra/helper/compTableHelper';
import { getCompType } from '../../../../services/Designs/compTypeHelper';
import { DIODE } from '../../../../constants/componentType';
import DiodeModelSection from './diodeModelSelection';
import preLayoutData from '../../../../services/Sierra/prelayout/preLayoutData';
import designConstructor from '../../../../services/helper/designConstructor';
import { getModelExist } from '../../../../services/Sierra/errorCheck';
import '../index.css';

const compColumns = [{
  title: 'Part Name',
  dataIndex: 'part',
  width: '25%',
  sorter: (a, b) => a.part.localeCompare(b.part),
}, {
  title: 'Components',
  dataIndex: 'comps',
  width: '15%',
}, {
  title: 'Usage',
  dataIndex: 'type',
  width: '10%',
  sorter: (a, b) => a.type.localeCompare(b.type),
}, {
  title: 'Model',
  dataIndex: 'value',
  width: '20%'
}, {
  title: 'Package',
  dataIndex: 'pkg',
  width: '20%'
}, {
  title: 'Probes',
  dataIndex: 'probes',
  width: '15%'
}];

class ComponentTable extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      mergePartList: [],
      mergeVisible: false,
      mergeType: '',
      displayPartNumber: false
    }

    this.getCompColumns();
  }

  getCompColumns = () => {

    compColumns[0].title = () => {
      const { displayPartNumber } = this.state;
      return <div>
        <span className='sierra-comp-table-part-title'>Part {displayPartNumber ? "Number" : "Name"}</span>
        <Tooltip
          title='Toggle to display part name or part number.'
          mouseLeaveDelay={0}
          mouseEnterDelay={0.3}
          classNames={{ root: 'icon-tooltip' }}
        >
          <RetweetOutlined
            className="sierra-comp-table-part-switch-icon"
            onClick={(e) => this.changePartDisplay(e)}
          />
        </Tooltip>
      </div>
    }
    compColumns[0].render = (text, record) => {
      const { mergeVisible, mergePartList, displayPartNumber } = this.state;
      const partText = displayPartNumber && record.partNumber ? record.partNumber : record.part; if (RLCTypes.includes(record.type) && mergePartList && mergePartList.length > 0 && mergePartList[0] === record.part) {
        return <Popover
          placement="topLeft"
          classNames={{ root: 'merge-part-popover' }}
          getPopupContainer={() => document.getElementById('sierra-component-row')}
          content={<Fragment>
            <Tooltip title='Merge Part' mouseLeaveDelay={0} mouseEnterDelay={0.3} classNames={{ root: 'icon-tooltip' }}>
              <span className='merge-part-popover-span' onClick={(e) => this.MergePart(e, record)}>Merge</span>
            </Tooltip>
          </Fragment>}
          open={mergeVisible}
        >
          <span onClick={(e) => this.tableOnRow(e, record)} className='sierra-part-name cursor-pointer'>{partText}</span>
        </Popover>
      } else if (RLCTypes.includes(record.type)) {
        return <span className='cursor-pointer sierra-part-name' onClick={(e) => this.tableOnRow(e, record)}>{partText}</span>
      } else {
        return <span className='sierra-part-name'>{partText}</span>
      }
    }

    compColumns[1].onCell = (record) => {
      const { comps, pcbId } = record;
      const { doNotStuff } = this.props;
      const pcbDoNotStuff = doNotStuff ? doNotStuff[pcbId] || [] : [];
      let compsName = [], doNotStuffComps = [];
      comps.map(item => {
        if (item.type !== UNUSED) {
          compsName.push({
            name: item.name,
            checked: true
          });

        } else {
          compsName.push({
            name: item.name,
            checked: false
          });
        }
        if (pcbDoNotStuff.includes(item.name)) {
          doNotStuffComps.push(item.name);
        }
        return null;
      });

      return RLCTypes.includes(record.type) ? {
        record,
        compsName,
        edit: true,
        customInput: TableTag,
        dataIndex: "comps",
        popupContainer: record.comps.length > 1 ? 'sierra-component-row' : 'sierra-content-main',
        changeCompsChecked: this.changeCompsChecked,
        //changeDecapRemove: this.changeDecapRemove,
        select: this.componentSelect,
        splitComps: this.splitComps,
        onClick: (e) => this.spanClick(e),
        isPCBOpened: this.isPCBOpened,
        doNotStuffComps
      } : null
    }

    compColumns[1].render = (comps, record) => {
      const mac = isMac();
      let tdRef = document.getElementById(`td-${record.index}`);
      const height = tdRef && tdRef.offsetHeight;
      let names = [];
      const isRLC = RLCTypes.includes(record.type);
      comps.forEach(item => {
        if (item.type !== UNUSED || !isRLC) {
          names.push(item.name);
        }
      })
      return <div
        className='sierra-table-comp' id='sierra-component-row'>
        <span className={!isRLC ? 'sierra-comp-usage-rlc' : ""}
          onClick={!isRLC ? () => this.componentSelect(record, names) : null}>
          {names.length > 0 ? names.join(', ') : "Unstuffed"}
        </span>
        {mac && height && height > 88 ? <div className='sierra-component-arrow'></div> : null}
      </div>
    };

    compColumns[2].onCell = (record) => {
      if (!this.props.pcbLoading && !RLCTypes.includes(record.COMP_TYPE)) {
        const options = this.getCompType(record.type, record.COMP_TYPE);
        const { Interfaces, current } = this.props;
        const compType = getCompTypeDisplay(Interfaces, current, record);
        return {
          record: { ...record, type: compType },
          edit: 'select',
          options: options,
          dataIndex: 'type',
          handleSave: (row) => this.editComponentType(row, compType)
        };
      } else {
        return {
          edit: false
        }
      }
    }

    compColumns[2].render = (text, record) => {
      if (!RLCTypes.includes(record.COMP_TYPE)) {
        const { Interfaces, current } = this.props;
        const displayType = getCompTypeDisplay(Interfaces, current, record);
        const className = this.props.pcbLoading ? "sierra-comp-usage-rlc" : "";
        return displayType === IC_MASTER ? <span className={className}>IC<span className='sierra-comp-type-tag'> (Master)</span></span>
          : <span className={className}>{displayType}</span>
      } else {
        return <span className="sierra-comp-usage-rlc">{record.type}</span>
      }
    }

    compColumns[3].render = (text, record) => {
      let className = "", _text = ""
      if (RLCTypes.includes(record.type)) {
        _text = formatRLCValue(record.type, text, record.model);
      } else if (record.type === COMP_REPEATER) {
        _text = <span className='sierra-repeater-editable-cell-value-wrap'>{getRepeaterText(record)}</span>
      } else if (ICTypes.includes(record.type)) {
        //model:[files:[ { fileName, folder, libraryId, type,subckt } ]]
        const text = getModelFileText(record);
        const component = record.model.files && record.model.files.length > 0 && record.model.files[0].libraryId && record.model.files[0].component;
        _text = `${text}${component ? `:: ${component}` : ''}`;
        className = "sierra-ic-editable-cell-value-wrap";
      } else if (record.type === DIODE) {
        className = "sierra-ic-editable-cell-value-wrap";
        _text = record.model && record.model.fileName && (record.model.modelName || record.model.subckt) ? `${record.model.fileName}::${record.model.modelName || record.model.subckt}` : (record.model || {}).fileName;
      }

      if (record.notExistModels && record.notExistModels.length) {
        const key = record.notExistModels.length > 1 ? "have" : "has"
        return <div>
          <span className={`${className} sierra-error-file-span`}>{_text}</span>
          <Tooltip
            title={`File ${record.notExistModels.join(", ")} ${key} been deleted, the model is invalid.`}
            classNames={{ root: 'aurora-tooltip' }}
          ><QuestionCircleOutlined className='aurora-file-check-icon' onClick={(e) => this.spanClick(e)} />
          </Tooltip>
        </div>
      } else {
        return <span className={className}>{_text}</span>
      }
    }

    compColumns[3].onCell = (record) => {
      if (RLCTypes.includes(record.type)) {
        const { passiveSpiceList, passiveTouchstoneList } = this.props;
        const { pcbPowerNets, nets } = this.getNetsOptions(record)
        return {
          edit: true,
          text: <span>{formatRLCValue(record.type, record.value, record.model)}</span>,
          record: { ...record, model: this.getRLCModel(record) },
          customInput: RLCCompModel,
          dataIndex: 'model',
          powerNets: nets,
          saveRLCModel: this.saveRLCModel,
          spiceList: passiveSpiceList,
          touchstoneList: passiveTouchstoneList,
          getFileContent: getLibraryFileContent,
          parseModelSelector: parseSpiceModelSelector,
          product: SIERRA,
          pcbPowerNets,
          passivePins: this.getPassivePins({ record, pcbPowerNets })
        }
      } else if (record.type === COMP_REPEATER) {
        let model = {};
        if (record.model && record.model.id) {
          model = { files: [], pairs: [] };
          model.files[0] = {
            folder: "",
            fileName: record.model.name,
            libraryId: record.model.id,
            subckt: record.model.subcktName,
            type: COMP_REPEATER
          }
        } else if (record.model.files) {
          model = { ...record.model }
        }
        const pins = record.comps && record.comps[0] && Array.isArray(record.comps[0].pins) ? record.comps[0].pins : [];
        const compName = record.comps && record.comps[0] ? record.comps[0].name : "";
        const text = getRepeaterText(record);
        const { verificationId, repeaterList, genericTouchstoneList, repeaterTouchstoneList, genericSpiceList } = this.props;
        return {
          edit: true,
          verificationId,
          record,
          model,
          pins,
          text,
          compName,
          product: SIERRA,
          displayType: "model",
          className: 'sierra-repeater-editable-cell-value-wrap',
          customInput: PinNodeConnect,
          libraryList: repeaterList ? repeaterList : [],
          genericSpiceList: genericSpiceList,
          genericTouchstoneList: genericTouchstoneList,
          touchstoneList: repeaterTouchstoneList,
          dataIndex: 'model',
          saveLibraryModel: this.saveRepeaterModel,
          getLibraryFile: getLibraryRepeaterFile,
          getFolderFileDetail,
          modelType: COMP_REPEATER,
          componentSetting,
          designId: record.pcbId,
          autoAssignRepeaterPorts,
          getTouchstoneParse,
        }
      } else if (ICTypes.includes(record.type)) {
        const componentName = record.comps && record.comps[0] ? record.comps[0].name : null;
        const { verificationId, ibisList, spiceList, currentProjectId, autoAssignStatus, updateAssignStatus } = this.props;
        const pins = record.comps && record.comps[0] && Array.isArray(record.comps[0].pins) ? record.comps[0].pins : [];
        const compModel = this.getComponentModel(componentName, record);
        const component = record.model.files && record.model.files.length > 0 && record.model.files[0].libraryId && record.model.files[0].component
        const text = getModelFileText(record) + (component ? `:: ${component}` : '');
        return {
          edit: true,
          verificationId,
          record,
          componentName,
          compModel,
          currentProjectId,
          autoAssignStatus,
          customInput: ICModelPanel,
          product: SIERRA,
          pins,
          displayType: "file",
          className: 'sierra-ic-editable-cell-value-wrap',
          text,
          ibisList,
          spiceList,
          dataIndex: 'model',
          applyModelObj: record.applyModelObj,
          saveLibraryModel: this.saveChipModel,
          updateAssignStatus: updateAssignStatus,
          getIbisModelList: getIbisModelList,
          getIbisPackageList: getIbisPackageList,
          getSpiceModelList: getSpiceModelList,
          getFolderFileDetail
        }
      } else if (record.type === DIODE) {
        const { genericSpiceList, passiveSpiceList } = this.props;
        return {
          edit: true,
          record,
          customInput: DiodeModelSection,
          passiveSpiceList: passiveSpiceList || [],
          genericSpiceList: genericSpiceList || [],
          dataIndex: 'model',
          saveLibraryModel: this.saveDiodeModel
        }
      } else {
        return {
          edit: false,
        }
      }
    }

    compColumns[4].onCell = (record) => {
      const { pcbId, comps } = record;
      const componentName = comps && comps[0] ? comps[0].name : "";
      const pinList = record.comps && record.comps[0] ? this.getPinList(componentName, pcbId) : [];
      const { verificationId, pkgSpiceList, pkgTouchstoneList } = this.props;
      const text = getIBISPackageText(record.pkg);
      if (ICTypes.includes(record.type)) {
        return {
          edit: true,
          record,
          componentName,
          pinList,
          text,
          customInput: PackageModel,
          dataIndex: 'pkg',
          product: SIERRA,
          savePackageModel: this._savePackageModel,
          spiceList: pkgSpiceList,
          touchstoneList: pkgTouchstoneList,
          PackageModelInfo: PackageModelInfo,
          PackageModelFileInfo: PackageModelFileInfo,
          getIbisPackageList: getIbisPackageList,
          getTouchstoneParse: getTouchstoneParse,
          getSPiceParse: getPkgSpiceModelList,
          autoSelectPorts: autoSelectTouchstonePorts,
          verificationId,
          modelType: 'Package',
          displayType: 'model'
        }
      } else {
        return {
          edit: false
        }
      }
    }

    compColumns[4].render = (text, record) => {
      const pkg = record.pkg;
      if (pkg && ICTypes.includes(record.type)) {
        if (pkg.type === 'None') {
          return <span>{pkg.type}</span>
        } else if (pkg.type === 'IBIS') {
          const text = getIBISPackageText(pkg);
          return <span>{text}</span>;
        } else if (pkg.type === "SPICE" || pkg.type === "Touchstone" || pkg.type === "Touchstone / SPICE") {
          const { text } = getSpicePackageText(pkg, record);

          const key = record.notExistModels && record.notExistModels.length > 1 ? "have" : "has";
          return record.notExistPkgModels && record.notExistPkgModels.length ?
            <div>
              <span>{text}</span>
              <Tooltip
                title={`File ${record.notExistPkgModels.join(", ")} ${key} been deleted, the model is invalid.`}
                classNames={{ root: 'aurora-tooltip' }}
              ><QuestionCircleOutlined className='aurora-file-check-icon' onClick={(e) => this.spanClick(e)} />
              </Tooltip>
            </div> : <span>{text}</span>;
        }
      } else {
        return <span className='sierra-corner-row-disabled'></span>
      }
    }

    compColumns[5].onCell = (record) => {
      const { verificationId } = this.props;
      if (!probePinsPointTypes.includes(record.type)) {
        const text = getProbePinsText(record);
        return {
          edit: true,
          record,
          text,
          product: SIERRA,
          components: record.comps ? record.comps : [],
          customInput: ProbePinsPanel,
          verificationId,
          className: 'sierra-component-probes-td-content',
          dataIndex: 'probes',
          closeModal: this.closeProbeModal
        };
      } else {
        return {
          edit: false
        }
      }
    }

    compColumns[5].render = (text, record) => {
      if (probePinsPointTypes.includes(record.type)) {
        return <span className='sierra-corner-row-disabled'></span>
      } else {
        const text = getProbePinsText(record);
        return <Tooltip
          classNames={{ root: 'aurora-tooltip' }}
          title={text}
        >
          <span className='sierra-component-probes-td'>{text}</span>
        </Tooltip>
      }
    }
  }

  changePartDisplay = (e) => {
    e && e.stopPropagation();
    this.setState({
      displayPartNumber: !this.state.displayPartNumber
    })
  }

  isPCBOpened = (record) => {
    const { pcbId } = record;
    const { selectedDesignIDs } = this.props;
    return selectedDesignIDs.includes(pcbId);
  }

  getRLCModel = (record) => {
    const { model = {}, value, type } = record;
    let _value = getRLCValue(type, value);
    if (type === JUMPER) { _value = { r: value } }
    const passiveModel = new PassiveModel({ ...model });
    const _model = new RLCModelInfo({ modelType: model.type ? model.type.toLowerCase() : model.type, value: _value, passiveModel });
    return { ..._model };
  }

  getNetsOptions = (record) => {
    const { Interfaces } = this.props;
    let currentInterface = Interfaces ? Interfaces.find(item => item.pcbId === record.pcbId) : null;
    let nets = [], signalNets = [], pwrGndNets = [], pcbPowerNets = [];
    if (currentInterface && currentInterface.content) {
      if (currentInterface.content.signals) {
        //get signal nets
        currentInterface.content.signals.forEach(item => {
          if (item.nets && item.nets.length > 0) {
            signalNets = [...signalNets, ...item.nets]
          }
        })
      }

      //get power gnd nets
      if (currentInterface.content.powerNets) {
        currentInterface.content.powerNets.forEach(item => {
          if (item.name) {
            pwrGndNets.push(item.name);
          }
        })
        pcbPowerNets = currentInterface.content.powerNets;
      }
    }
    nets = [...signalNets, ...pwrGndNets];
    return { nets, pcbPowerNets };
  }

  getPassivePins = ({ record, pcbPowerNets }) => {
    const { comps } = record;
    const pcbId = record.pcbId;
    const isPreLayout = record.pcbId ? designConstructor.isPreLayout(pcbId) : false;
    let pins = [];
    for (const comp of comps) {
      const _pins = comp && comp.pins ? comp.pins : []
      pins = [...pins, ...(_pins.map(item => item.pin))];
    }
    const compName = comps[0].name;

    if (pins.length === 1 && isPreLayout) {
      let powerPin = "PWR"
      if (preLayoutData.isSchematic(pcbId)) {
        const findPower = pcbPowerNets.find(item => item.comps && item.comps.includes(compName));
        powerPin = findPower && findPower.name ? findPower.name : "PWR";
      } else {
        const components = preLayoutData.getComponents(pcbId) || []
        const findComp = components.find(item => item.name === compName);
        if (findComp) {
          powerPin = parseFloat(findComp.voltage) > 0 ? "PWR" : "GND"
        }
      }
      pins.push(powerPin)
    }
    return pins;
  }

  tableOnRow = (e, record) => {
    e.stopPropagation();
    const { part } = record;
    const { mergePartList, mergeVisible, mergeType } = this.state;
    if (mergePartList && mergePartList.length > 0) {
      if (record.type !== mergeType) {
        message.info("Please select components of the same type to merge")
        return;
      }
    }
    let partList = [...mergePartList], visible = mergeVisible;
    if (!mergePartList.includes(part)) {
      partList.push(part);
    } else {
      partList = partList.filter(item => item !== part);
    }
    if (partList.length > 1) {
      visible = true;
    } else {
      visible = false;
    }
    this.setState({
      mergePartList: partList,
      splitPartName: null,
      mergeVisible: visible,
      mergeType: record.type
    })
  }


  getPinList = (compName, pcbId) => {
    const { Interfaces } = this.props;
    let pinList = [];
    if (!compName || !Interfaces || !Interfaces.length) {
      return pinList;
    }

    const currentInterface = Interfaces.find(item => item.pcbId === pcbId);
    let Components = [];
    if (currentInterface && currentInterface.content && currentInterface.content.components) {
      Components = currentInterface.content.components;
    }
    const Comp = Components.find(item => item.name === compName);
    if (Comp && Comp.pins) {
      Comp.pins.forEach(item => {
        pinList.push({
          pin: item.pin,
          net: item.net,
          signal: item.signal
        })
      })
    }
    return pinList;
  }

  spanClick = (e) => {
    e.stopPropagation();
  }

  _savePackageModel = (pkg, record) => {
    const { comps, pcb, pcbId } = record;
    if (comps && comps[0]) {
      this.props._saveCompPackageModel(pkg, comps[0].name, pcb, pcbId);
    }
  }

  getComponentModel = (compName, record) => {
    const { pcbId } = record;
    const { Interfaces } = this.props;
    const currentInterface = (Interfaces || []).find(item => item.pcbId === pcbId);
    let components = [];
    if (currentInterface && currentInterface.content && currentInterface.content.components) {
      components = currentInterface.content.components;
    }
    let model = null;
    const compFind = components.find(item => item.name === compName);
    if (compFind && compFind.model) {
      model = compFind.model;
    }
    return model;
  }

  componentSelect = (record, names) => {
    const { pcbId } = record;
    if (this.isPCBOpened(record)) {
      const layout = canvas.getLayout(pcbId);
      let layers = layout.findCurrentLayer(names);
      layers = [...new Set(layers)];
      this.props._selectLayer(layers, pcbId);
      this.props._selectChange({ comps: [...names] }, pcbId);
      this.props.changeDisplaySelected(true, pcbId);
    }
  }

  saveDecapModel = (record, value) => {
    const { comps, pcb, pcbId } = record;
    const { Interfaces } = this.props;
    let _Interfaces = [...Interfaces];
    const _index = _Interfaces.findIndex(item => item.pcbId === pcbId);
    const editInterface = _Interfaces[_index].content;
    let components = [...editInterface.components];
    comps.forEach(item => {
      const compIndex = components.findIndex(comp => comp.name === item.name);
      components[compIndex].value = value;
    })

    _Interfaces[_index].content.components = [...components];
    this.props._updateInterfaces({ Interfaces: _Interfaces, pcb, pcbId });
  }

  saveRepeaterModel = (model, record) => {
    const { pcb, pcbId, comps } = record;
    if (comps && Array.isArray(comps) && comps[0]) {
      const name = comps[0].name;//component name
      this.props._saveRepeater({ model, name, pcb, pcbId });
    }
  }

  saveChipModel = async ({ files, libType, pairs, record, applyModelObj }) => {
    const { pcb, pcbId, comps } = record;
    this.props._saveChip({ files, libType, pairs, pcb, pcbId, name: comps[0].name, applyModelObj });
  }

  saveRLCModel = (model, record) => {
    const { pcb, pcbId, part, comps } = record;
    const _model = { type: getModelTypeName(model.type), ...model.passiveModel };
    const value = getModelValue(record.type, model.value);
    this.props._saveRLC({ model: _model, pcb, pcbId, value, part, comps });
  }

  getCompType = (type, COMP_TYPE) => {
    let options = [];
    switch (type) {
      case RES:
      case IND:
      case CAP:
      case JUMPER:
        options = [COMP_TYPE, UNUSED];
        break;
      case COMP_REPEATER:
      case IC:
      case CHIP:
      case CONNECTOR:
        options = [IC, COMP_REPEATER, CONNECTOR, UNUSED];
        break;
      case TEST_POINT:
        options = [TEST_POINT_DISPLAY, UNUSED, CONNECTOR];
        break;
      case DIODE:
        options = [DIODE, UNUSED];
        break;
      case UNUSED:

        if (RLCTypes.includes(COMP_TYPE)) {
          options = [COMP_TYPE, UNUSED];
          break;
        }
        if (ChipTypes.includes(COMP_TYPE)) {
          options = [IC, COMP_REPEATER, CONNECTOR, UNUSED];
          break;
        }

        if (COMP_TYPE === TEST_POINT) {
          options = [TEST_POINT_DISPLAY, UNUSED, CONNECTOR];
          break;
        }

        if (COMP_TYPE === DIODE) {
          options = [DIODE, UNUSED];
          break;
        }

        options = [IC, COMP_REPEATER, CONNECTOR, TEST_POINT_DISPLAY, CAP, IND, RES, JUMPER, UNUSED];
        break;
      // case JUMPER:
      //   options = [type, UNUSED];
      //   break
      default: break;
    }
    if (options.includes(IC)) {
      const icIndex = options.indexOf(IC);
      options.splice(icIndex + 1, 0, IC_MASTER);
    }
    return options;
  }

  editComponentType = (row, prevType) => {
    const { type, pcbId, comps } = row;
    this.props._editComponentType({ type, comps, pcbId, prevType });
  }

  changeCompsChecked = (compsName, checked, record) => {
    const { part, pcb, pcbId, type } = record;
    let chips = [...compsName];
    this.props._updateCompComponents({ part, chips, checked, _type: type, pcb, pcbId });
  }

  splitComps = (compList, record) => {
    const { part, pcb, pcbId } = record;
    let partName = part;
    const comps = this.getComponents();
    const newPartName = getSplitPartName({ components: comps, partName });
    this.setState({
      splitPartName: newPartName,
      mergePartList: []
    });
    this.props.saveSplitComponents({ part, splitPart: newPartName, comps: compList, pcb, pcbId });
    setTimeout(() => {
      this.setState({
        splitPartName: null
      });
    }, 3000);
  }

  MergePart = (e, record) => {
    e.stopPropagation();
    const { mergePartList } = this.state;
    const { pcb, pcbId } = record;
    if (mergePartList.length === 0) {
      return;
    }
    let partName = mergePartList[0];
    this.props.saveMergeComponents({ part: partName, partList: mergePartList, pcb, pcbId });
    this.setState({
      mergePartName: partName,
      mergePartList: []
    });
    setTimeout(() => {
      this.setState({
        mergePartName: null
      });
    }, 3000);
  }

  getComponents = () => {
    const { current, compPrefixLibInfo, compPinMap = {}, Interfaces } = this.props;
    let _components = getComponentsByPCB(Interfaces, current);
    let preCompInfo = {}
    let _partComps = []; // [{part, comps, value, type}]
    _components.forEach((comp) => {
      const { part, name, pins, probePins = [], applyModelObj, pcbId, pcb } = comp;
      const partNumber = auroraDBJson.getPartNumberByPartName(pcbId, part);
      //ignore to unused
      const type = comp.type === IGNORE ? UNUSED : comp.type;
      const pinList = auroraDBJson.getCompPinList(pcbId, name);
      const allPinsLength = pinList.length;
      const passiveTable = compTableHelper.get(pcbId);
      let compType = type;
      const findPassive = passiveTable.find(item => item.part === part);
      if (findPassive && findPassive.usage) {
        compType = findPassive.usage;
      } else {
        compType = getCompType({ compName: name, pinLength: allPinsLength, COMP_PREFIX_LIB: compPrefixLibInfo[pcbId], partName: part, product: SIERRA, compPinMap: compPinMap[pcbId] })
      }

      if (![UNUSED, IGNORE].includes(compType) && ![UNUSED, IGNORE].includes(type) && compType !== type) {
        //compType === Res, type === Cap
        compType = type;
      }
      //ignore to unused
      compType = compType === IGNORE ? UNUSED : compType;

      if (designConstructor.isPreLayout(pcbId)) {
        preCompInfo[pcbId] = !preCompInfo[pcbId] ? preLayoutData.getComponents(pcbId) || [] : preCompInfo[pcbId];
        const findPreComp = preCompInfo[pcbId].find(item => item.name === name);
        compType = findPreComp && findPreComp.type ? findPreComp.type : compType;
      }

      const rlcIndex = _partComps.findIndex(item => item.part === part);
      if (RLCTypes.includes(compType)) {
        if (rlcIndex > -1 && _partComps[rlcIndex].type === compType) {
          //according to type and part separate comp.
          _partComps[rlcIndex].comps.push({ name, pins, type, probePins, allPinsLength });
        } else {
          const notExistModels = comp.model && ["Touchstone", "SPICE"].includes(comp.model.type) ? getModelExist({ model: comp.model, modelType: "PASSIVE" }) : null;
          _partComps.push({
            part,
            partNumber,
            comps: [{ name, pins, type, probePins, allPinsLength }],
            type: compType,
            COMP_TYPE: compType,
            value: comp.value,
            model: comp.model,
            pcb,
            pcbId,
            notExistModels
          });
        }
      } else if ([...RLCTypes, DIODE].includes(type)) {
        if (rlcIndex > -1 && _partComps[rlcIndex].type === type) {
          //according to type and part separate comp.
          _partComps[rlcIndex].comps.push({ name, pins, type, probePins, allPinsLength });
        } else {
          const notExistModels = comp.model && ["Touchstone", "SPICE"].includes(comp.model.type) ? getModelExist({ model: comp.model, modelType: "PASSIVE" }) : null;
          _partComps.push({
            part,
            partNumber,
            comps: [{ name, pins, type, probePins, allPinsLength }],
            type,
            COMP_TYPE: type === DIODE ? type : compType,
            value: comp.value,
            model: comp.model,
            pcb,
            pcbId,
            notExistModels
          });
        }
      } else if (ChipTypes.includes(type)) {
        //const notExist = comp.model && comp.model.fileName ? this.getFileExist(comp.model) : false;
        //const packageFileNotExist = comp.pkg && comp.pkg.type ? this.getPackageFileExist(comp.pkg) : false;

        let notExistModels = null, notExistPkgModels = null;
        if (comp.type === COMP_REPEATER && comp.model && comp.model.files && comp.model.files.length) {
          notExistModels = getModelExist({ files: comp.model.files, model: comp.model, modelType: "REPEATER" });
        } else if (comp.type === IC || comp.type === CHIP) {
          notExistModels = comp.model && comp.model.files && comp.model.files.length ? getModelExist({ files: comp.model.files, modelType: "BUFFER" }) : null;
          notExistPkgModels = comp.pkg && comp.pkg.files && comp.pkg.files.length ? getModelExist({ files: comp.pkg.files, modelType: "PKG" }) : null
        }
        _partComps.push({
          part,
          partNumber,
          comps: [{ name, pins, type, allPinsLength }],
          type,
          COMP_TYPE: type,
          model: comp.model,
          pcb,
          pcbId,
          pkg: comp.pkg ? comp.pkg : null,
          applyModelObj,
          notExistModels,
          notExistPkgModels
        });
      } else {

        _partComps.push({
          part,
          partNumber,
          comps: [{ name, pins, type, probePins, allPinsLength }],
          type,
          COMP_TYPE: compType === DIODE ? compType : type,
          value: comp.value,
          model: comp.model,
          pcb,
          pcbId,
          pkg: comp.pkg ? comp.pkg : null,
          applyModelObj
        });
      }
    });
    const sort = [CHIP, IC, COMP_REPEATER, CONNECTOR, CAP, RES, JUMPER, IND, DIODE, TEST_POINT, UNUSED];
    _partComps = SortFn(_partComps, sort, 'COMP_TYPE');
    return _partComps;
  }

  closeProbeModal = (probePinsList, record) => {
    const { part, pcbId } = record;
    this.props._updateProbePins({ probePinsList, part, pcbId });
  }

  saveDiodeModel = (model, record) => {
    this.props._updateDiodeModel(model, record);
  }

  render() {
    const { mergePartList, splitPartName, mergePartName } = this.state;
    const dataList = this.getComponents() || [];
    let scroll = {};
    if (dataList && dataList.length && dataList.length > 9) {
      scroll = {
        scroll: {
          y: 342
        }
      }
    }
    return (
      <EditableTable
        rowKey={(record) => `${record.pcbId}-${record.part}-${record.comps.map(item => item.name).join('-')}`}
        columns={compColumns}
        size="small"
        dataSource={dataList}
        scroll={scroll}
        className='sierra-component-table space-10'
        onRow={record => {
          let rowClassName = '';
          if (record.part === splitPartName && mergePartList.length === 0 && !mergePartName) {
            rowClassName = 'sierra-component-split-row'
          } else if (mergePartList.length > 0 && mergePartList.includes(record.part) && !mergePartName) {
            rowClassName = 'sierra-component-select-row'
          } else if (mergePartName && record.part === mergePartName) {
            rowClassName = 'sierra-component-merge-row'
          }
          return RLCTypes.includes(record.type) && {
            className: rowClassName
          };
        }}
      />
    )
  }
}

const mapState = (state) => {
  const { SierraReducer: { sierra, project: { currentProjectId, verificationId, selectedKeys }, library: { initLibraryStatus } } } = state;
  const autoAssignStatus = sierra.autoAssignStatus
  const sierraInfo = sierra.sierraInfo;
  let Interfaces = [], currentPCBs = [];
  if (sierraInfo) {
    Interfaces = sierraInfo.Interfaces || [];
    currentPCBs = sierraInfo.Interfaces ? sierraInfo.Interfaces.map(item => item.pcbId) : [];
  }
  return {
    Interfaces,
    currentPCBs,
    currentProjectId,
    verificationId,
    pcbLoading: sierra.pcbLoading,
    selectedDesignIDs: getSelectedDesignIDs(selectedKeys),
    autoAssignStatus,
    updateCompPrefixLibStatus: sierra.updateCompPrefixLibStatus,
    initLibraryStatus
  }
};

const mapDispatch = (dispatch) => ({
  _editComponentType({ type, comps, pcbId, prevType }) {
    dispatch(editComponentType({ type, comps, pcbId, prevType }));
  },
  _updateInterfaces({ Interfaces, pcb, pcbId }) {
    dispatch(updateInterfaces({ Interfaces, pcb, pcbId }));
  },
  _saveRepeater({ model, name, pcb, pcbId }) {
    dispatch(saveRepeater({ model, name, pcb, pcbId }));
  },
  _saveChip({ /* model, fileInfo, use, */files, libType, pairs, pcb, pcbId, name, pkg, applyModelObj }) {
    dispatch(saveChip({ /* model, fileInfo, use, */files, libType, pairs, pcb, pcbId, name, pkg, applyModelObj }));
  },
  _saveRLC({ model, pcb, pcbId, value, part, comps }) {
    dispatch(saveRLC({ model, pcb, pcbId, value, part, comps }));
  },
  _selectChange(obj = {}, designID) {
    dispatch(selectChange(obj, designID))
  },
  _selectLayer(layers, designID) {
    dispatch(selectLayer(layers, designID));
  },
  changeDisplaySelected(show, designID) {
    dispatch(changeDisplaySelected(show, designID))
  },
  _updateCompComponents({ part, chips, checked, _type, pcb, pcbId }) {
    dispatch(updateCompComponents({ part, chips, checked, _type, pcb, pcbId }))
  },
  _saveCompPackageModel(pkg, component, pcb, pcbId) {
    dispatch(saveCompPackageModel(pkg, component, pcb, pcbId))
  },
  saveSplitComponents({ part, splitPart, comps, pcb, pcbId }) {
    dispatch(saveSplitComponents({ part, splitPart, comps, pcb, pcbId }))
  },
  saveMergeComponents({ part, partList, pcb, pcbId }) {
    dispatch(saveMergeComponents({ part, partList, pcb, pcbId }))
  },
  _updateProbePins({ probePinsList, part, pcbId }) {
    dispatch(updateProbePins({ probePinsList, part, pcbId }))
  },
  updateAssignStatus(status) {
    dispatch(updateAssignStatus(status))
  },
  _updateGetCompPrefixStatus(status) {
    dispatch(updateGetCompPrefixStatus(status))
  },
  _updateDiodeModel(model, record) {
    dispatch(updateDiodeModel(model, record));
  }
})

export default connect(mapState, mapDispatch)(ComponentTable);
